import { ChangeDetectionStrategy, Component, computed, inject, ViewEncapsulation } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AtButtonDirective, AtIconComponent, ConfigurableAuthService } from '@anothertrip/anothertrip-ds';

@Component({
  selector: 'app-page-not-found',
  imports: [AtIconComponent, AtButtonDirective, RouterLink],
  templateUrl: './page-not-found.page.html',
  styleUrl: './page-not-found.page.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageNotFoundPage {
  private readonly authService = inject(ConfigurableAuthService);

  protected readonly isLoggedIn = this.authService.isLoggedIn;

  protected readonly links = computed<{ url: string; label: string }[]>(() =>
    this.isLoggedIn()
      ? [
          { url: '/dashboard', label: 'Dashboard' },
          { url: '/campaigns', label: 'Campaigns' },
        ]
      : [
          { url: '/login', label: 'Sign In' },
          { url: '/register', label: 'Sign Up' },
        ]
  );
}
